import API from "./authApi";

// ----- PALEONTOLOGOS -------------
export const createPaleo = (data) => API.post("/paleos", data);
export const listPaleos = () => API.get("/paleos");
export const getPaleo = (id) => API.get(`/paleos/${id}`);
export const updatePaleo = (id, data) => API.put(`/paleos/${id}`, data);
export const deletePaleo = (id) => API.delete(`/paleos/${id}`);

// ------------- DINOSAURIOS -----
export const createDino = (data) => API.post("/dinos", data);
export const listDinos = () => API.get("/dinos");
export const getDino = (id) => API.get(`/dinos/${id}`);
export const updateDino = (id, data) => API.put(`/dinos/${id}`, data);
export const deleteDino = (id) => API.delete(`/dinos/${id}`);
